import { Pipe, PipeTransform } from '@angular/core';

import { TableColumn } from '../interfaces/table.interface';

@Pipe({
  name: 'tableRow',
})
export class TableRowPipe implements PipeTransform {
  transform(data :any, columns :TableColumn<any>[]) :any {
    return Object.keys(data).map((key) => {
      const column = columns.find((column) => column.property === key);

      return {
        key,
        value: data[key],
        column,
      };
    });
  }
}
